// Simple i18n with PT default + EN
export const LANGUAGES = ["pt", "en"];

export const dict = {
  pt: {
    nav: {
      dining: "Cozinha",
      distribution: "Distribuição",
      back: "Voltar",
      home: "Início",
      story: "História",
      events: "Eventos",
      gallery: "Galeria",
      products: "Produtos",
      pricing: "Preços",
      wholesale: "B2B",
      collection: "Pontos de recolha",
      admin: "Admin",
    },
    gateway: {
      tagline: "Cozinha mediterrânica. Tábua, Coimbra.",
      diningTitle: "Lama Hummus",
      diningSub: "Pop-ups, hummus & shawarma",
      diningCta: "Entrar",
      distTitle: "Lama Distribution",
      distSub: "Mercearia mediterrânica B2C & B2B",
      distCta: "Entrar",
      footer: "© Lama — Tábua · Coimbra · Portugal",
    },
    dining: {
      heroOverline: "Próxima refeição",
      heroTitle: "Hummus, shawarma\ne uma mesa partilhada.",
      heroLead:
        "Lama é cozinha mediterrânica feita devagar, no centro de Portugal — em pop-ups íntimos e eventos privados.",
      cta: "Reservar lugar",
      noEvent: "Sem eventos agendados de momento.",
      followIg: "Acompanhar no Instagram",
      menuTitle: "Menu do evento",
      menuFootnote: "Preços em EUR. Sujeitos a disponibilidade.",
      storyOverline: "A nossa história",
      storyTitle: "Dois cozinheiros,\numa só mesa.",
      galleryOverline: "Galeria",
      galleryTitle: "Imagens de mesa.",
      reserveTitle: "Quero ir ao próximo Lama",
      reserveLead: "Envie-nos uma mensagem e reservamos o seu lugar.",
      formName: "Nome",
      formEmail: "Email",
      formPhone: "Telefone (opcional)",
      formGuests: "Nº de pessoas",
      formMessage: "Mensagem",
      formSubmit: "Enviar pedido",
      formSent: "Pedido enviado. Voltamos rapidamente.",
    },
    dist: {
      heroOverline: "Distribuição",
      heroTitle: "O Mediterrâneo,\nentregue à sua porta.",
      pricingOverline: "Tabela de preços",
      pricingTitle: "Retalho & Grossista",
      colProduct: "Produto",
      colUnit: "Formato",
      colOrigin: "Origem",
      colRetail: "Retalho (1–9)",
      colWholesale: "Grossista (10+)",
      catalogOverline: "Catálogo",
      catalogTitle: "Produtos selecionados.",
      ingredients: "Ingredientes",
      retail: "Retalho",
      wholesale: "Grossista",
      requestB2b: "Abrir conta empresarial",
      collectionOverline: "Pontos de recolha",
      collectionTitle: "Onde levantar a sua encomenda.",
      b2bTitle: "Abrir conta empresarial",
      b2bLead: "Restaurantes, mercearias e pequenos retalhistas. Resposta em 48h.",
      formBusiness: "Nome da empresa",
      formContact: "Pessoa de contacto",
      formEmail: "Email",
      formPhone: "Telefone",
      formNif: "NIF",
      formAddress: "Morada",
      formVolume: "Volume estimado / mês",
      formMessage: "Mensagem",
      formSubmit: "Enviar pedido",
      formSent: "Pedido recebido. Entraremos em contacto.",
    },
    admin: {
      loginTitle: "Acesso admin",
      email: "Email",
      password: "Palavra-passe",
      login: "Entrar",
      logout: "Sair",
      tabEvents: "Eventos",
      tabProducts: "Produtos",
      tabRequests: "Pedidos B2B",
      tabPoints: "Pontos de recolha",
      tabContent: "Conteúdo",
      addNew: "Adicionar",
      save: "Guardar",
      delete: "Apagar",
      cancel: "Cancelar",
      edit: "Editar",
    },
  },
  en: {
    nav: {
      dining: "Dining",
      distribution: "Distribution",
      back: "Back",
      home: "Home",
      story: "Story",
      events: "Events",
      gallery: "Gallery",
      products: "Products",
      pricing: "Pricing",
      wholesale: "B2B",
      collection: "Pickup points",
      admin: "Admin",
    },
    gateway: {
      tagline: "Mediterranean kitchen. Tábua, Coimbra.",
      diningTitle: "Lama Hummus",
      diningSub: "Pop-ups, hummus & shawarma",
      diningCta: "Enter",
      distTitle: "Lama Distribution",
      distSub: "Mediterranean grocery, B2C & B2B",
      distCta: "Enter",
      footer: "© Lama — Tábua · Coimbra · Portugal",
    },
    dining: {
      heroOverline: "Next meal",
      heroTitle: "Hummus, shawarma\nand a shared table.",
      heroLead:
        "Lama is slow Mediterranean cooking in the heart of Portugal — intimate pop-ups and private events.",
      cta: "Reserve a seat",
      noEvent: "No events scheduled at the moment.",
      followIg: "Follow on Instagram",
      menuTitle: "Event menu",
      menuFootnote: "Prices in EUR. Subject to availability.",
      storyOverline: "Our story",
      storyTitle: "Two cooks,\none table.",
      galleryOverline: "Gallery",
      galleryTitle: "Images from the table.",
      reserveTitle: "I want to join the next Lama",
      reserveLead: "Send us a note and we’ll save your seat.",
      formName: "Name",
      formEmail: "Email",
      formPhone: "Phone (optional)",
      formGuests: "Guests",
      formMessage: "Message",
      formSubmit: "Send request",
      formSent: "Request sent. We'll be in touch shortly.",
    },
    dist: {
      heroOverline: "Distribution",
      heroTitle: "The Mediterranean,\ndelivered.",
      pricingOverline: "Pricing table",
      pricingTitle: "Retail & Wholesale",
      colProduct: "Product",
      colUnit: "Unit",
      colOrigin: "Origin",
      colRetail: "Retail (1–9)",
      colWholesale: "Wholesale (10+)",
      catalogOverline: "Catalog",
      catalogTitle: "Hand-picked products.",
      ingredients: "Ingredients",
      retail: "Retail",
      wholesale: "Wholesale",
      requestB2b: "Open business account",
      collectionOverline: "Pickup points",
      collectionTitle: "Where to collect your order.",
      b2bTitle: "Open a business account",
      b2bLead: "Restaurants, grocers and small retailers. Reply within 48h.",
      formBusiness: "Business name",
      formContact: "Contact person",
      formEmail: "Email",
      formPhone: "Phone",
      formNif: "VAT / NIF",
      formAddress: "Address",
      formVolume: "Estimated volume / month",
      formMessage: "Message",
      formSubmit: "Send request",
      formSent: "Request received. We'll get back to you.",
    },
    admin: {
      loginTitle: "Admin access",
      email: "Email",
      password: "Password",
      login: "Log in",
      logout: "Log out",
      tabEvents: "Events",
      tabProducts: "Products",
      tabRequests: "B2B requests",
      tabPoints: "Pickup points",
      tabContent: "Content",
      addNew: "Add",
      save: "Save",
      delete: "Delete",
      cancel: "Cancel",
      edit: "Edit",
    },
  },
};

export function t(lang, path) {
  const parts = path.split(".");
  let cur = dict[lang] || dict.pt;
  for (const p of parts) {
    if (cur && p in cur) cur = cur[p];
    else return path;
  }
  return cur;
}
